import React from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../utils/config";
import { useLocation, useParams } from 'react-router-dom';

function Card({ title, image, kmcontent,price,currency,slug,cardtype, listingType,kms_driven,fuel_type,transmission_type, banner, url, type,type_product ,POA,featured, priceAboveTitle = false, priceWithDecimals = false, sellerType}) {
  const navigate = useNavigate();
  const displayPrice =
    priceWithDecimals &&
    sellerType === "Sellanything" &&
    price !== null &&
    price !== undefined &&
    price !== "" &&
    Number.isFinite(Number(price))
      ? Number(price).toFixed(2)
      : price;
  const priceContent = POA !== 'Yes' ? (
    price ? (
      <div className="pricelarge">
        {currency ? `${currency} ` : ''}{displayPrice}{" "}
      </div>
    ) : null
  ) : (
    <div className="pricelarge">POA</div>
  );
  const validityIndex =
    priceAboveTitle && typeof title === "string"
      ? title.search(/\bvalid\b/i)
      : -1;
  const titleContent =
    validityIndex >= 0 ? title.slice(0, validityIndex).trimEnd() : title;
  const validityContent =
    validityIndex >= 0 ? title.slice(validityIndex).trim() : "";
 

  const handleCardClick = (productSlug,POA) => {
    // console.log('eeeeeeeeeeeeee22222',cardtype)
    if (cardtype === 'automobile') {
      if(POA == 'Yes'){
      navigate("/detail/" + productSlug + '/automobile?POA');
      } else {
        navigate("/detail/" + productSlug + '/automobile');
      }
      
    } else {
      navigate("/detail/" + productSlug + '/product');
    }
  };
  const handleCardClickPOA = (productSlug) => {
    // console.log('eeeeeeeeeeeeee22222',cardtype)
    if (cardtype === 'automobile') {
      navigate("/detail/" + productSlug + '/automobile/POA');
      
    } 
  };
  
 
  const handleScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (
    listingType === "google_ads"  ) {
    return (
      <div className="item google_ads" onClick={handleScrollUp}>
        <div className="ad-box" style={{ cursor: "pointer" }}>
  
          <a href={`${url}`}>
            <div className="ad-image">
              <img src={`${API_BASE_URL}${banner}`} alt={title} />
            </div>
            {/* <div className="ad-content">
              <div className="ad-title">{title}</div>
              <div className="ad-location">
                <i className="location icon-07"></i> {kmcontent}{" "}
                <i className="chat icon-04"></i>
              </div>
            </div> */}
          </a>
        </div>
      </div>
    );
  } else {
    return (
      <div className="item" onClick={handleScrollUp}>
        <div
          className="ad-box"
          onClick={() => handleCardClick(slug,POA)}
          style={{ cursor: "pointer" }}
        >
        
        <div className="ad-image">
  {cardtype === 'automobile' ? (
    <>
      <img
        src={API_BASE_URL + image}
        alt={title}
        onError={(e) => {
          e.target.src = '../../img/product-palaceholder.png';
        }}
      />
      {type_product !== null && type_product !== '' && (
        <div
          className={
            type_product === 'FEATURED'
              ? 'featuredside'
              : type_product === 'PREMIUM'
              ? 'premiumside'
              : type_product === 'CAR OF THE DAY'
              ? 'cardayside'
              : ''
          }
        >
          {type_product}
        </div>
      )}
    </>
  ) : (
    <>
      <img
        src={image}
        alt={title}
        onError={(e) => {
          e.target.src = '../../img/product-palaceholder.png';
        }}
      />
      {featured !== null && featured !== '' && (
        <div className={featured === '1' ? 'featuredside' : ''}>FEATURED</div>
      )}
    </>
  )}
</div>

          <div className="ad-content">
            {priceAboveTitle && priceContent}
            <div className={`ad-title${priceAboveTitle ? " ad-title-unclamped" : ""}`}>
              {titleContent}
            </div>
            {validityContent && (
              <div className="ad-location validity-location">
                <div className="locoutermain d-flex">
                  <span className="locitems">{validityContent}</span>
                </div>
              </div>
            )}
            {cardtype == 'automobile' ? 
  <div className="ad-location">
   <div className="locoutermain d-flex">
    {kms_driven ? 
    <span className="locitems"> {kms_driven}{" kms       "}</span> 
    :''} 
    {fuel_type ?
    <span className="locitems"> {fuel_type}{"       "}</span>   
    :''}
    {transmission_type ?
    <span className="locitems">{transmission_type}</span>
    :""}
   </div>
  </div>
: ''}

           {!priceAboveTitle && priceContent}
         {sellerType !== 'Sellanything' && kmcontent !== '' && kmcontent !== undefined ?
           <div className="ad-location adlocation-bottom">
            
              <i className="location icon-07"></i> {kmcontent}{" "} 
              {/* <i className="chat icon-04"></i> */}
            </div>
            :''}
        
          </div>
          {/* </a> */}
        </div>
      </div>
    );
  }
}

export default Card;
